module.exports = "/to_the_arctic_for_practice/_next/static/videos/14-4b143ad3138178cf1d35bfccdf697110.mp4";